module.exports = __webpack_public_path__ + "img/aidtools_8.f75bdcd0.png";